// extracted by mini-css-extract-plugin
export default {"wrapper":"Interests_wrapper__worWA"};